import { StoreCategoriesTree } from "@/components/e-commerce/store/categories-sidebar/tree"
import { getStoreCategoriesTree } from "~/services/dokan-service"

interface StoreCategoriesSidebarProps {
  storeId: number
}

export const StoreCategoriesSidebar = async ({
  storeId,
}: StoreCategoriesSidebarProps): Promise<React.ReactNode> => {
  const categories = await getStoreCategoriesTree(storeId)

  if (categories.length === 0) {
    return (
      <aside className='h-fit rounded-xl border border-gray-200 bg-gray-50 p-4 lg:sticky lg:top-24'>
        <h2 className='font-semibold text-gray-900 text-xl'>Categorias</h2>
        <p className='mt-4 text-gray-500 text-sm'>
          Sem categorias para esta loja.
        </p>
      </aside>
    )
  }

  return (
    <aside className='h-fit rounded-xl border border-gray-200 bg-gray-50 p-4 lg:sticky lg:top-24'>
      <h2 className='font-semibold text-gray-900 text-xl'>Categorias</h2>

      <StoreCategoriesTree categories={categories} />
    </aside>
  )
}
